import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnClose = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return () => {
    navigate(navigation.timeOff.fullPath())
  }
}
